import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessToken } from "@shared/api/getAccessToken";
import { API } from "../authSlice";
import { hideModals } from "../layoutSlice";

export const confirmSmsCode = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/verifyCode",
    async (payload: any, thunkAPI) => {
        const TOKEN = getAccessToken();

        try {
            const response = await fetch(`${API}/v1/verification/phone/second_step`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth-token": TOKEN
                },
                body: JSON.stringify(payload)
            });

            let data = await response.json();

            if (response.status >= 200 && response.status < 300) {
                thunkAPI.dispatch(hideModals());
            }

            return {
                status: response.status,
                data: data
            };
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);